import Bus from "@/utils/bus";
import { UserCardAction, UserCardType } from "@/types/UserCard";
import { FocusSDK, isHomePageUrl } from "@/utils";
// import log from '@/utils/logger';
// const logger = log.getLogger('modal:app');

export interface UserCardState {
  type: UserCardType;
  visible: boolean;
  appId: string;
  userId: string;
  notPersonalCalendar?: boolean;
  teamId: string;
  rootOrgId?: string;
  group?: any;
  actions?: UserCardAction[];
  applyInfos?: string[];
  currentUser?: {
    userId: string;
    teamId: string;
    appId: string;
    realName: string;
    station: string;
  };
  deptId?: string;
  needMask?: boolean;
  needMaskName?: boolean;
  robotData?: any;
  footExtra?: any;
}

export interface OrgAcctModalState {
  visible: boolean;
  subId: string;
  followCb?: any;
}

export interface ModalsState {
  userCard: UserCardState;
  orgAcctModal: OrgAcctModalState;
}

export interface UserCardPayload {
  type?: UserCardType;
  visible: boolean;
  appId: string;
  userId: string;
  teamId: string;
  rootOrgId?: string;
  group?: any;
  notPersonalCalendar?: boolean;
  actions?: UserCardAction[];
  applyInfos?: string[];
  currentUser?: {
    userId: string;
    teamId: string;
    appId: string;
    realName: string;
    station: string;
  };
  deptId?: string;
  friendErrMsg?: string;
  isfriend?: number;
  needMask?: boolean;
  needMaskName?: boolean;
  robotData?: any;
  flag?: number;
  reply?: number;
  footExtra?: any;
}

export interface OrgAcctPayload {
  visible: boolean;
  subId: string;
}

export interface AppState {
  rightLoadState: CompDataLoadState;
  rightPageType: DefaultPageType;
  modals: ModalsState;
  toggleUserCardModal: Function;
  updatePageLoadState: Function;
}

export enum DefaultPageType {
  NO_DATA = "no_data", // 统一 无数据
  DARK_NO_DATA = "dark_no_data", // 统一 无数据
  KEYWORD = "keyword", // 搜索页 关键词
  GROUP = "group", // 通讯录 我的群组
  CREATE_GROUP = "create_group", // 通讯录  我创建的组
  JOIN_GROUP = "join_group", // 通讯录  我加入的组
  SESSION = "session", // 会话
  MESSAGE = "message", // 消息
  AT = "at", // at
  SEARCH_HISTORY = "search_history", // 搜索聊天记录
  CHAT_HISTORY_FILE = "chat_history_file", // 历史记录 没有文件
  CHAT_HISTORY_RECORD = "chat_history_record", // 历史访录 聊天记录
  CHAT_HISTORY_IMG_VIDEO = "chat_history_img_video", // 历史记录 图片视频
  CONTACT_ADMIN = "contact_admin", // 联系管理员配置应用
  APP_SETTING = "app_setting", // 请前往管理后台配置应用
  LOAD_FAILED = "load_failed", // 加载失败
  LOW_VERSION = "low_version", // 低版本
  CHECK_NETWORK_CONN = "check_network_conn", // 网络连接失败
  EXTERNAL_CONTACT = "external_contact", // 外部联系人
  NEW_CONTACT = "new_contact", // 外部联系人
  HIDE_IMAGE = "hide_image", // 空图片
  PUBLIC_ACCOUNT = "public_account", // 公共账号
  PUBLIC_USAGE = "public_usage", // 公共账号使用人
  IMG_DEFAULT = "img_default", // 只展示京办图片
  MY_DEPARTMENT = "my_department", // 我的部门
  TAG = "tag", // 标签
  SUB = "sub", // 广播号
  NO_USERS_DATA = "no_users_data",
  NODETA_DEPT = "nodata_dept",
  ORG = "org",
  REQUEST_FAIL = "request_fail" // 请求接口失败
}

export enum CompDataLoadState {
  INIT = "init", // 初始化
  LOADING = "loading", // 加载中
  ERROR = "error", // 调用数据接口失败
  NODATA = "nodata", // 数据接口没有返回数据
  NORMAL = "normal", // 正常显示
  NOUSERSDATA = "NOUSERSDATA", // 通讯录大屏版 暂无人员、设备
  NODETA_DEPT = "nodata_dept" // 大屏暂无部门数据
}

export default {
  namespace: "app",
  state: {
    modals: {
      userCard: {
        type: UserCardType.User,
        visible: false,
        userId: "",
        teamId: "",
        appId: "",
        group: {},
        actions: [],
        applyInfos: [],
        currentUser: {}
      },
      orgAcctModal: {
        visible: false,
        subId: ""
      }
    },
    rightLoadState: CompDataLoadState.INIT,
    rightPageType: null
  },
  reducers: {
    toggleUserCardModal(state: AppState, { payload }: { payload: UserCardPayload }) {
      console.log("toggleUserCardModal-payload:", payload);
      if (!isHomePageUrl()) {
        FocusSDK.sendToMain("ai:openUserCard", {
          app: payload.appId,
          teamId: payload.teamId,
          userId: payload.userId
        });
        return state;
      }
      const { modals } = state;
      if (!payload.visible) {
        payload.group = {};
        payload.teamId = "";
        payload.notPersonalCalendar = undefined;
        payload.userId = "";
        payload.appId = "";
        payload.rootOrgId = undefined;
        payload.applyInfos = [];
        payload.actions = [];
        payload.deptId = "";
        payload.friendErrMsg = "";
        payload.needMask = false;
        payload.needMaskName = false;
        payload.flag = 0;
        payload.reply = 0;
        payload.footExtra = undefined;
      }
      const userCard = Object.assign(modals.userCard, payload);
      return { ...state, modals: { ...modals, userCard } };
    },
    toggleOrgAcctModal(state: AppState, { payload }: { payload: OrgAcctPayload }) {
      console.log("toggleUserCardModal-payload:", payload);
      // if (!isHomePageUrl()) {
      //   FocusSDK.sendToMain("ai:openUserCard", {
      //     app: payload.appId,
      //     teamId: payload.teamId,
      //     userId: payload.userId
      //   });
      //   return state;
      // }
      const { modals } = state;
      if (!payload.visible) {
        payload.subId = "";
      }
      const orgAcctModal = Object.assign(modals.orgAcctModal, payload);
      console.log("dainjiguangbohao====", orgAcctModal);
      
      return { ...state, modals: { ...modals, orgAcctModal } };
    },
    updatePageLoadState(state: AppState, { payload }: any) {
      const { rightLoadState, rightPageType } = payload;
      return {
        ...state,
        rightLoadState,
        rightPageType
      };
    }
  },
  subscriptions: {
    "app-event"({ dispatch }: any) {
      Bus.on("app:default-page-nodata", (rightPageType) => {
        const payload = {
          rightLoadState: CompDataLoadState.NODATA,
          rightPageType
        };
        dispatch({ type: "updatePageLoadState", payload: payload });
      });
      Bus.on("app:default-page-loading", () => {
        const payload = {
          rightLoadState: CompDataLoadState.LOADING,
          rightPageType: null
        };
        dispatch({ type: "updatePageLoadState", payload: payload });
      });
      Bus.on("app:default-page-init", () => {
        const payload = {
          rightLoadState: CompDataLoadState.INIT,
          rightPageType: null
        };
        dispatch({ type: "updatePageLoadState", payload: payload });
      });
      Bus.on("app:default-page-normal", () => {
        const payload = {
          rightLoadState: CompDataLoadState.NORMAL,
          rightPageType: null
        };
        dispatch({ type: "updatePageLoadState", payload: payload });
      });

      Bus.on("app:default-page-error", () => {
        const payload = {
          rightLoadState: CompDataLoadState.ERROR,
          rightPageType: DefaultPageType.LOAD_FAILED
        };
        dispatch({ type: "updatePageLoadState", payload: payload });
      });

      Bus.on("app:toggle-user-card-modal:show", (data) => {
        dispatch({ type: "toggleUserCardModal", payload: data });
      });
      Bus.on("app:toggle-user-card-modal:hide", (data) => {
        dispatch({ type: "toggleUserCardModal", payload: { visible: false, robotData: null } });
      });

      Bus.on("app:toggle-org-acct-modal:show", (data) => {
        dispatch({ type: "toggleOrgAcctModal", payload: data });
      });
      Bus.on("app:toggle-org-acct-modal:hide", (data) => {
        dispatch({ type: "toggleOrgAcctModal", payload: { visible: false } });
      });
    }
  }
};
